export default {
  alertColor: '#0C8ED7',
  noIssueColor: '#dbb167',
  customerViewBarChartColor: '#3796A6',
  autoCloseColor: '#4CAF50',
  strColor: '#E85252',
  strProgressColor: '#E85252',
  conversionColor: '#8971E9',
  ruleBasedColor: '#F5C987',
  issueColor: '#FF934F',
  anomalyColor: '#A18CE8',
  anomalyProgressColor: '#BC23DA',
  noColor: '#666',
  randomColor: random_rgba
};

// export default {
//   alertColor: "#0C8ED7",
//   noIssueColor: "#9ED85B",
//   autoCloseColor: "#4CAF50",
//   strColor: "#E85252",
//   conversionColor: "#8971E9",
//   ruleBasedColor: "#F5C987",
//   issueColor: "#FF934F",
//   anomalyColor: "#BC23DA",
//   noColor: "#666",
//   randomColor: random_rgba
// }

function random_rgba() {
  var o = Math.round,
    r = Math.random,
    s = 255;
  return (
    'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + 0.8 + ')'
  );
}

export const nsColorConstants = {
  alerts: '#3184dc',
  hits: '#FF934F',
  falseHits: '#6E78B9',
  trueHits: '#FF1E00',
  undetermined: '#3786A6',
  autoClosed: '#579C87',
  hitsYield: '#8971E9',
  ruleBasedColor: '#F5C987',
  throughPut: '#335777',
  peerAvg: '#6bbed7',
  time: '#69050ccc',
  randomColor: random_rgba()
};

export const defaultSliderStartVal = 0;
export const defaultSliderEndVal = 5000;

export const tmDefaultPageSize = 20;

export const dateTimeFormat = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const DDMMYYYYFormat = 'DD/MM/YYYY';
export const DDMMYYYYTimeFormat = 'DD/MM/YYYY HH:mm:ss';
export const DDMMYYYYHHMMTimeFormat = 'DD/MM/YYYY HH:mm';
export const DDMMYYYYHHMMTimeFormatForFileDownload = 'DD-MM-YYYY_HHmm';
export const YYYYMMDDFormat = 'YYYY/MM/DD';
export const YYYYMMDDFormatWithHyphen = 'YYYY-MM-DD';
export const timezoneDiffTimeFormat = 'Z';
export const timezoneTextFormat = 'z';

export const nsResources = {
  APP_3_RESOURCE_UI_NS_ALERTS_LIST: 'APP_3_RESOURCE_UI_NS_ALERTS_LIST',
  APP_3_RESOURCE_UI_NS_IAD_SEGMENTS: 'APP_3_RESOURCE_UI_NS_IAD_SEGMENTS',
  APP_3_RESOURCE_UI_NS_INVESTIGATION_PAGE:
    'APP_3_RESOURCE_UI_NS_INVESTIGATION_PAGE',
  APP_3_RESOURCE_UI_NS_RISK_VIEW: 'APP_3_RESOURCE_UI_NS_RISK_VIEW',
  APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG:
    'APP_3_RESOURCE_UI_NS_IAD_MATCHING_CONFIG',
  APP_3_RESOURCE_UI_NS_IAD_ALERT_DETAILS:
    'APP_3_RESOURCE_UI_NS_IAD_ALERT_DETAILS',
  APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE:
    'APP_3_RESOURCE_UI_NS_IAD_MATCHING_RUN_INSTANCE',
  APP_3_RESOURCE_UI_NS_IAD_WATCHLIST: 'APP_3_RESOURCE_UI_NS_IAD_WATCHLIST',
  APP_3_RESOURCE_UI_NS_IAD_WHITELIST: 'APP_3_RESOURCE_UI_NS_IAD_WHITELIST',
  APP_3_RESOURCE_UI_NS_IAD_GLOBAL_SETTINGS:
    'APP_3_RESOURCE_UI_NS_IAD_UI_CONFIG_MANAGEMENT',
  APP_3_RESOURCE_UI_AMLS_COMMON_TICKET: 'APP_3_RESOURCE_UI_AMLS_COMMON_TICKET',
  APP_3_RESOURCE_UI_NS_IAD_TICKET_DETAILS:
    'APP_3_RESOURCE_UI_NS_IAD_TICKET_DETAILS',
  APP_3_RESOURCE_UI_ON_DEMAND_SCREENING:
    'APP_3_RESOURCE_UI_ON_DEMAND_SCREENING',
  APP_3_RESOURCE_UI_AMLS_COMMON_NOTIFICATIONS:
    'APP_3_RESOURCE_UI_AMLS_COMMON_NOTIFICATIONS'
};

export const nsUserManagementResourcesArray = {
  nsDashboard: [
    'NS_ALERTS_HITS_CHART_WIDGET',
    'NS_HITS_DISTRIBUTTION_CHART_WIDGET',
    'NS_BUSINESS_SEGMENT_PARAMETERS_CHART_WIDGET',
    'NS_CUSTOMER_VIEW_CHART_WIDGET'
  ],

  nsAlertListing: ['APP_3_RESOURCE_UI_NS_ALERTS_LIST'],

  nsAlertDetails: ['NS_CUSTOMER_PROFILE_WIDGET', 'NS_ALERT_DETAILS_WIDGET']
};

export const nsUserManagementResources = {
  // ns dashboard
  NS_ALERTS_HITS_CHART_WIDGET: 'NS_ALERTS_HITS_CHART_WIDGET',
  NS_HITS_DISTRIBUTTION_CHART_WIDGET: 'NS_HITS_DISTRIBUTTION_CHART_WIDGET',
  NS_BUSINESS_SEGMENT_PARAMETERS_CHART_WIDGET:
    'NS_BUSINESS_SEGMENT_PARAMETERS_CHART_WIDGET',
  NS_CUSTOMER_VIEW_CHART_WIDGET: 'NS_CUSTOMER_VIEW_CHART_WIDGET',

  // ns alert listing
  APP_3_RESOURCE_UI_NS_ALERTS_LIST: 'APP_3_RESOURCE_UI_NS_ALERTS_LIST',

  // ns alert details
  NS_CUSTOMER_PROFILE_WIDGET: 'NS_CUSTOMER_PROFILE_WIDGET',
  NS_ALERT_DETAILS_WIDGET: 'NS_ALERT_DETAILS_WIDGET'
};

export const tmResources = {
  APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES:
    'APP_3_RESOURCE_UI_TM_ALERT_LIST_ANOMALIES',
  APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS:
    'APP_3_RESOURCE_UI_TM_ALERT_LIST_ALERTS',
  APP_3_RESOURCE_UI_TM_DASHBOARD: 'APP_3_RESOURCE_UI_TM_DASHBOARD',
  APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE:
    'APP_3_RESOURCE_UI_TM_INVESTIGATION_PAGE',
  APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT:
    'APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT',
  APP_3_RESOURCE_UI_TM_ANOMALY_INVESTIGATION:
    'APP_3_RESOURCE_UI_TM_ANOMALY_INVESTIGATION',
  APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS: 'APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS',
  APP_3_RESOURCE_UI_TM_CONFIGURATION: 'APP_3_RESOURCE_UI_TM_CONFIGURATION',
  APP_3_RESOURCE_UI_TM_IAD_FULLACCESS: 'APP_3_RESOURCE_UI_TM_IAD_FULLACCESS'
};

export const tmUserManagementResourcesArray = {
  tmDashboard: [
    'TM_ALERTS_ANOMALIES_CHART_WIDGET',
    'TM_ALERTS_YIELD_CHART_WIDGET',
    'TM_NO_ISSUE_L1_CHART_WIDGET',
    'TM_STR_CHART_WIDGET',
    'TM_SEGMENTS_CHART_WIDGET',
    'TM_CUSTOMER_VIEW_CHART_WIDGET',
    'TM_CLUSTER_VIEW_CHART_WIDGET'
  ],

  tmAlertListing: ['TM_ALERTS_LISTING_WIDGET'],
  tmAlertDetails: [
    'APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT',
    'TM_CUSTOMER_PROFILE_WIDGET',
    'TM_ASSOCIATED_CUSTOMER_WIDGET',
    'TM_ASSOCIATED_ACCOUNTS_WIDGET',
    'TM_ANOMALY_DISPOSITION_NOTES_WIDGET',
    'TM_EXPLAINABILITY_WIDGET',
    'TM_TRANSACTION_DETAILS_WIDGET',
    'TM_ALERT_DETAILS_WIDGET',
    'TM_CUSTOMER_ACTIVITY_WIDGET',
    'TM_ADDITIONAL_INFO_WIDGET',
    'TM_RISK_INDICATOR_WIDGET',
    'TM_CLUSTER_INFORMATION_WIDGET'
  ]
};

export const tmUserManagementResources = {
  // tm dashboard
  TM_ALERTS_ANOMALIES_CHART_WIDGET: 'TM_ALERTS_ANOMALIES_CHART_WIDGET',
  TM_ALERTS_YIELD_CHART_WIDGET: 'TM_ALERTS_YIELD_CHART_WIDGET',
  TM_NO_ISSUE_L1_CHART_WIDGET: 'TM_NO_ISSUE_L1_CHART_WIDGET',
  TM_STR_CHART_WIDGET: 'TM_STR_CHART_WIDGET',
  TM_SEGMENTS_CHART_WIDGET: 'TM_SEGMENTS_CHART_WIDGET',
  TM_CUSTOMER_VIEW_CHART_WIDGET: 'TM_CUSTOMER_VIEW_CHART_WIDGET',
  TM_CLUSTER_VIEW_CHART_WIDGET: 'TM_CLUSTER_VIEW_CHART_WIDGET',

  // tm alerts listing
  TM_ALERTS_LISTING_WIDGET: 'TM_ALERTS_LISTING_WIDGET',

  // tm alert details
  APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT:
    'APP_3_RESOURCE_UI_TM_ANOMALY_MANAGEMENT',
  TM_CUSTOMER_PROFILE_WIDGET: 'TM_CUSTOMER_PROFILE_WIDGET',
  TM_ASSOCIATED_CUSTOMER_WIDGET: 'TM_ASSOCIATED_CUSTOMER_WIDGET',
  TM_ASSOCIATED_ACCOUNTS_WIDGET: 'TM_ASSOCIATED_ACCOUNTS_WIDGET',
  TM_ANOMALY_DISPOSITION_NOTES_WIDGET: 'TM_ANOMALY_DISPOSITION_NOTES_WIDGET',
  TM_EXPLAINABILITY_WIDGET: 'TM_EXPLAINABILITY_WIDGET',
  TM_TRANSACTION_DETAILS_WIDGET: 'TM_TRANSACTION_DETAILS_WIDGET',
  TM_ALERT_DETAILS_WIDGET: 'TM_ALERT_DETAILS_WIDGET',
  TM_CUSTOMER_ACTIVITY_WIDGET: 'TM_CUSTOMER_ACTIVITY_WIDGET',
  TM_ADDITIONAL_INFO_WIDGET: 'TM_ADDITIONAL_INFO_WIDGET',
  TM_RISK_INDICATOR_WIDGET: 'TM_RISK_INDICATOR_WIDGET',
  TM_CLUSTER_INFORMATION_WIDGET: 'TM_CLUSTER_INFORMATION_WIDGET'
};

export const crsResources = {
  APP_3_RESOURCE_UI_CRS_DASHBOARD: 'APP_3_RESOURCE_UI_CRS_DASHBOARD',
  APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST: 'APP_3_RESOURCE_UI_CRS_CUSTOMER_LIST',
  APP_3_RESOURCE_UI_CRS_CUSTOMER_DETAIL:
    'APP_3_RESOURCE_UI_CRS_CUSTOMER_DETAIL',
  APP_3_RESOURCE_UI_CRS_RISK_INDICATOR_CONFIGURATION:
    'APP_3_RESOURCE_UI_CRS_RISK_INDICATOR_CONFIGURATION',
  APP_3_RESOURCE_UI_CRS_GLOBAL_SETTINGS:
    'APP_3_RESOURCE_UI_CRS_GLOBAL_SETTINGS',
  APP_3_RESOURCE_UI_CRS_CONFIGURE_RULES:
    'APP_3_RESOURCE_UI_CRS_CONFIGURE_RULES',
  APP_3_RESOURCE_UI_CRS_TRIGGER_RE_SCORING:
    'APP_3_RESOURCE_UI_CRS_TRIGGER_RE_SCORING',
  APP_3_RESOURCE_UI_CRS_CHANGE_OR_ACCEPT_RISK_SCORE:
    'APP_3_RESOURCE_UI_CRS_CHANGE_OR_ACCEPT_RISK_SCORE'
};

export const trmResources = {
  APP_3_RESOURCE_UI_TYPOLOGY: 'APP_3_RESOURCE_UI_TYPOLOGY',
  APP_3_RESOURCE_UI_RUN_INSTANCE: 'APP_3_RESOURCE_UI_RUN_INSTANCE',
  APP_3_RESOURCE_UI_AMLS_TM_ALERT_DETAILS:
    'APP_3_RESOURCE_UI_AMLS_TM_ALERT_DETAILS',
  APP_3_RESOURCE_UI_AMLS_COMMON_ALERTS: 'APP_3_RESOURCE_UI_AMLS_COMMON_ALERTS',
  APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS: 'APP_3_RESOURCE_UI_TM_GLOBAL_SETTINGS',
  APP_3_RESOURCE_UI_AMLS_CHAMPION: 'APP_3_RESOURCE_UI_AMLS_CHAMPION',
  APP_3_RESOURCE_UI_AMLS_COMMON_TICKET: 'APP_3_RESOURCE_UI_AMLS_COMMON_TICKET',
  APP_3_RESOURCE_UI_AMLS_TM_TICKET_DETAILS:
    'APP_3_RESOURCE_UI_AMLS_TM_TICKET_DETAILS',
  APP_3_RESOURCE_UI_SEGMENT_DETAILS: 'APP_3_RESOURCE_UI_SEGMENT_DETAILS'
};

export const cmResources = {
  APP_7_RESOURCE_UI_CM_GENERIC: 'APP_7_RESOURCE_UI_CM_GENERIC',
  APP_7_RESOURCE_UI_CM_DASHBOARD: 'APP_7_RESOURCE_UI_CM_DASHBOARD',
  APP_7_RESOURCE_UI_CM_ALERT_LIST: 'APP_7_RESOURCE_UI_CM_ALERT_LIST',
  APP_7_RESOURCE_UI_CM_ALERT_HISTORY: 'APP_7_RESOURCE_UI_CM_ALERT_HISTORY',
  APP_7_RESOURCE_UI_CM_OWN_ALERTS_ACTIONS:
    'APP_7_RESOURCE_UI_CM_OWN_ALERTS_ACTIONS',
  APP_7_RESOURCE_UI_CM_OTHERS_ALERTS_ACTIONS:
    'APP_7_RESOURCE_UI_CM_OTHERS_ALERTS_ACTIONS',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS_ACTIONS:
    'APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS_ACTIONS',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS:
    'APP_7_RESOURCE_UI_CM_UNASSIGNED_ALERTS',
  APP_7_RESOURCE_UI_CM_CASES_BY_DEPARTMENT:
    'APP_7_RESOURCE_UI_CM_CASES_BY_DEPARTMENT',
  APP_7_RESOURCE_UI_CM_CASES_BY_INVESTIGATOR:
    'APP_7_RESOURCE_UI_CM_CASES_BY_INVESTIGATOR',
  APP_7_RESOURCE_UI_CM_OWN_CASES_ACTIONS:
    'APP_7_RESOURCE_UI_CM_OWN_CASES_ACTIONS',
  APP_7_RESOURCE_UI_CM_OTHERS_CASES_ACTIONS:
    'APP_7_RESOURCE_UI_CM_OTHERS_CASES_ACTIONS',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES_ACTIONS:
    'APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES_ACTIONS',
  APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES:
    'APP_7_RESOURCE_UI_CM_UNASSIGNED_CASES',
  APP_7_RESOURCE_UI_CM_MANUAL_CASE_CREATION:
    'APP_7_RESOURCE_UI_CM_MANUAL_CASE_CREATION',
  APP_7_RESOURCE_UI_CM_CASE_RESOLUTION_REVIEW:
    'APP_7_RESOURCE_UI_CM_CASE_RESOLUTION_REVIEW',
  APP_7_RESOURCE_UI_CM_DASHBOARD_SUMMARY:
    'APP_7_RESOURCE_UI_CM_DASHBOARD_SUMMARY',
  APP_7_RESOURCE_UI_CM_DASHBOARD_CASES_BY_INVESTIGATOR:
    'APP_7_RESOURCE_UI_CM_DASHBOARD_CASES_BY_INVESTIGATOR',
  APP_7_RESOURCE_UI_CM_OTHERS_DEPARTMENTS:
    'APP_7_RESOURCE_UI_CM_OTHERS_DEPARTMENTS',
  APP_7_RESOURCE_UI_CM_EMAIL_PREFERENCES:
    'APP_7_RESOURCE_UI_CM_EMAIL_PREFERENCES',
  APP_7_RESOURCE_UI_CM_GENERAL_SETTINGS:
    'APP_7_RESOURCE_UI_CM_GENERAL_SETTINGS',
  APP_7_RESOURCE_UI_CM_AUTOMATION_SETTINGS:
    'APP_7_RESOURCE_UI_CM_AUTOMATION_SETTINGS',
  APP_7_RESOURCE_UI_CM_REGULATORY_REPORT:
    'APP_7_RESOURCE_UI_CM_REGULATORY_REPORT',
  APP_7_RESOURCE_UI_CM_WORKFLOW_STATUSES:
    'APP_7_RESOURCE_UI_CM_WORKFLOW_STATUSES',
  APP_7_RESOURCE_UI_CM_OPERATIONAL_REPORT:
    'APP_7_RESOURCE_UI_CM_OPERATIONAL_REPORT',
  APP_7_RESOURCE_UI_CM_WHITELISTS: 'APP_7_RESOURCE_UI_CM_WHITELISTS'
};

export const TM_FRAUD_SOURCE_IDS = {
  TM: '8',
  FRAUD: '20',
  TM_PROD_ID: '6',
  FRAUD_PREVENTION_ID: '24',
  REAL_TIME_FRAUD: '24',
  FRAUD_PROD_ID: '21',
  FRAUD_PREV_ID: '24',
  TM_FRAUD_ID: '8,20',
  TM_PREV_ID: '8,24'
};

export const TM_FRAUD_PREVENTION_SOURCE_MAPPING = {
  TM_AML: 'AML-TM',
  FRAUD_PREVENTION: 'Fraud Prevention',
  FRAUD_DETECTION: 'Fraud Detection'
};

export const TM_FRAUD_SOURCE_STRINGS = {
  TMIAD: 'TMIAD',
  TMIAD_RUN_INSTANCE: 'TMIAD_RUN_INSTANCE',
  FRAUDIAD: 'FRAUDIAD',
  RTFRAUDIAD: 'RTFRAUDIAD',
  RTFRAUDIAD_BATCH: 'RTFRAUDIAD_BATCH'
};

export const sandboxResources = {
  APP_3_RESOURCE_UI_SCREENING_SANDBOX: 'APP_3_RESOURCE_UI_SCREENING_SANDBOX'
};

export const AMLS_MODULES_AND_ALERT_SOURCE_MAPPING = [
  { value: '7', mapping: ['NS', 'NAME SCREENING'], label: 'Name Screening' },
  {
    value: '9',
    mapping: ['TS', 'TRANSACTION SCREENING'],
    label: 'Transaction Screening'
  },
  {
    value: '16',
    mapping: ['PS', 'PROSPECT SCREEINING'],
    label: 'Prospect Name Screening'
  },
  {
    value: '17',
    mapping: ['RS', 'RISK SCORING'],
    label: 'Risk Scoring'
  }
];

export const ALERT_SOURCE_MAPPING = {
  NS: '7',
  TS: '9',
  PS: '16',
  RS: '17',
  PSRS: '16,17'
};

export const MODULE_SOURCEID_MAPPING = {
  'NS-IAD': '7',
  'TS-IAD': '9',
  PS: '16',
  RS: '17'
};

export const ALERT_SOURCEID_MAPPING = {
  2: 'NS',
  7: 'NS',
  9: 'TS',
  13: 'TS',
  16: 'PS',
  18: 'PS',
  27: 'NS',
  28: 'NS'
};

export const CRS_UI_DYNPROPS = 'APP_3_RESOURCE_UI_CRS_DYN_PROPS_LIST_PAGE';
export const CRS_UI_PIPELINES = 'APP_3_RESOURCE_UI_CRS_PIPELINE_LIST_PAGE';

export const NS_UI_DYNPROPS = 'APP_3_RESOURCE_UI_NS_IAD_DYN_PROPS_LIST_PAGE';
export const NS_UI_PIPELINES = 'APP_3_RESOURCE_UI_NS_IAD_PIPELINE_LIST_PAGE';

export const TS_UI_DYNPROPS = 'APP_3_RESOURCE_UI_TS_IAD_DYN_PROPS_LIST_PAGE';
export const TS_UI_PIPELINES = 'APP_3_RESOURCE_UI_TS_IAD_PIPELINE_LIST_PAGE';

export const TM_UI_DYNPROPS = 'APP_3_RESOURCE_UI_TM_IAD_DYN_PROPS_LIST_PAGE';
export const TM_UI_PIPELINES = 'APP_3_RESOURCE_UI_TM_IAD_PIPELINE_LIST_PAGE';
export const TM_UI_RI_DYNPROPS =
  'APP_3_RESOURCE_UI_TM_IAD_RI_DYN_PROPS_LIST_PAGE';
export const TM_UI_TYPOLOGY_DYNPROPS =
  'APP_3_RESOURCE_UI_TM_IAD_TYPOLOGY_DYN_PROPS_LIST_PAGE';

export const SCREENING_MODULEID_LIST = ['4', '5', '6', '7', '9', '10'];

export const GLOBAL_SETTINGS_SOURCE_MAPPING = {
  NS: {
    pageId: 'NS_IAD_ALERT_DETAILS',
    topPanelWidgetId: 'NS_IAD_ALERT_BASIC_DETAILS',
    topPanelWidgetGoupId: 'NS_IAD_ALERT_DETAILS_TOP_PANEL_GROUP',
    identityWidgetId: 'NS_IAD_ALERT_PARTY_IDENTITY',
    identityAndhitsExplainabilityWidgetGroupId:
      'NS_IAD_ALERT_PARTY_IDENTITY_AND_EXPLAINABILITY',
    hitsExplainabilityWidgetId: 'NS_IAD_HITS_AND_EXPLAINABILITY'
  },
  TS: {
    pageId: 'TS_IAD_ALERT_DETAILS',
    topPanelWidgetId: 'TS_IAD_ALERT_BASIC_DETAILS',
    topPanelWidgetGoupId: 'TS_IAD_ALERT_DETAILS_TOP_PANEL_GROUP',
    identityWidgetId: 'TS_IAD_ALERT_ENTITY_IDENTITY',
    identityAndhitsExplainabilityWidgetGroupId:
      'TS_IAD_ALERT_ENTITY_IDENTITY_AND_EXPLAINABILITY',
    hitsExplainabilityWidgetId: 'TS_IAD_HITS_AND_EXPLAINABILITY'
  },
  PS: {
    pageId: 'NS_IAD_ALERT_DETAILS',
    topPanelWidgetId: 'NS_IAD_ALERT_BASIC_DETAILS',
    topPanelWidgetGoupId: 'NS_IAD_ALERT_DETAILS_TOP_PANEL_GROUP',
    identityWidgetId: 'NS_IAD_ALERT_PARTY_IDENTITY',
    identityAndhitsExplainabilityWidgetGroupId:
      'NS_IAD_ALERT_PARTY_IDENTITY_AND_EXPLAINABILITY',
    hitsExplainabilityWidgetId: 'NS_IAD_HITS_AND_EXPLAINABILITY'
  }
};

export const ITEM_OPERATIONS = {
  CREATE: 'Write',
  READ: 'Read',
  EDIT: 'Update',
  DELETE: 'Delete',
  EXECUTE: 'Execute',
  FULL: 'Full'
};

export const dateFormat_DD_MM_YY = 'DD/MM/YYYY';
export const underScore_format_DD_MM_YY = 'DD_MM_YYYY';
export const DEFAULT_OFFSET = 0;
export const FeatureCategoryCodes_LC = 'featureCategoryCodes';
export const FeatureCodes_LC = 'featureCodes';
export const TransactionProductMapping = 'transactionProductMapping';
export const TransactionTypes = 'transactionTypes';
export const ClusterViewDescription_LC = 'clusterViewDescription';
export const COOKIE_NAME = 'tt_auth_token';
export const MAX_FRACTION_DIGITS = 6;
export const MIN_FRACTION_DIGITS = 2;
